import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { isIosNative } from '../commons/utils/platform';

// Apple's App Store guidelines forbid purchasing or purchase-steering UI in the iOS app itself
// (see AndroidPaymentHandoffGuard for why Android does the opposite). This guard blocks every
// route that lets a user start a new subscription, choose a plan, pay, or renew — new-tenant
// registration/account-setup and all payment/subscription-management entry points — on iOS
// only, redirecting to a neutral landing page. Web and Android are untouched.
@Injectable({ providedIn: 'root' })
export class IosPurchaseBlockGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    if (!isIosNative()) return true;
    return this.router.createUrlTree(['/plan-management-unavailable']);
  }
}
